/** Company uses Ommnio Sign as the configured e-signature integration (active or not). */
export function isOmmnioSignProvider(company) {
  return company?.eSignatureProvider?.name === 'ommniosign';
}

/** Ommnio Sign is enabled and billable for the company — document templates and palette apply. */
export function isActiveOmmnioSignProvider(company) {
  return isOmmnioSignProvider(company) && company?.eSignatureProvider?.isActive === true;
}

/** Public marketing URL for Ommnio Sign (locale-aware). */
export function getOmmnioSignMarketingSignUrl(locale) {
  const loc = String(locale || '').toLowerCase();
  if (loc === 'es' || loc.startsWith('es-')) {
    return 'https://www.ommnio.com/es/sign';
  }
  if (loc === 'ca' || loc.startsWith('ca-')) {
    return 'https://www.ommnio.com/ca/sign';
  }
  return 'https://www.ommnio.com/sign';
}
